<template>
    <!-- 상세 -->
    <div class="card card-default book-list">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form>
          <input type="hidden" />
          <table class="table table-bordered">
            <colgroup>
              <col width="10%" class="bg-lightdark" />
              <col width="17%" />
              <col width="8%" class="bg-lightdark"/>
              <col width="24%" />
              <col width="12%" class="bg-lightdark"/>
              <col width="30%" />
            </colgroup>
            <tr v-if="bookSeq != 0">
              <th>교재시퀀스</th>
              <td>
                <input type="text" v-model="data.bookSeq" :class="{'form-control':true}" name="bookSeq" style="width: 250px" readonly/>
              </td>
              <th>컨텐츠시퀀스</th>
              <td>
                <input type="text" v-model="data.contSeq" :class="{'form-control':true}" name="contSeq" style="width: 100%"  readonly/>
              </td>
              <th>교재ID</th>
              <td>
                <span v-show="data.bookId != ''" class="input-group">
                  <input type="text" v-model="data.bookId" :class="{'form-control':true}" name="bookId" style="width: 170px" readonly/>
                </span>
              </td>
            </tr>
            <tr>
              <th>{{bookTypeCd == '330001' ? "과목명" : "카테고리" }}*</th>
              <td v-if="bookTypeCd == '330001'">
                <label v-if="page.selectedSchoolType.length == 0">※ 학교급 선택시 목록이 노출됩니다.</label>
                <b-input-group>
                  <div v-show="page.selectedSchoolType == 'el'">
                    <b-form-select v-model="data.subjectCd" :options="page.subjectCd1" ></b-form-select>
                  </div>
                  <div v-show="page.selectedSchoolType == 'mid'">
                    <b-form-select v-model="data.subjectCd" :options="page.subjectCd2" ></b-form-select>
                  </div>
                  <div v-show="page.selectedSchoolType == 'high'">
                    <b-form-select v-model="data.subjectCd" :options="page.subjectCd3" ></b-form-select>
                  </div>
                </b-input-group>
              </td>
              <td v-if="bookTypeCd == '330002'">
                <b-form-select :options="cateCd" v-model="data.cateCd" @change="changeCateCd(data.cateCd)" 
                v-validate="'required'" name="cateCd"
                :class="{'form-control custom-select custom-select-sm mt-1 mb-2':true, 'is-invalid': errors.has('cateCd')}"></b-form-select>
                <b-form-select :options="page.subjectOption" v-model="data.subjectCd"
                v-validate="'required'" name="subjectCd"
                :class="{'form-control custom-select custom-select-sm':true, 'is-invalid': errors.has('subjectCd')}"></b-form-select>
              </td>
              <th>교재명*</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('textbookNm')}" v-model="data.textbookNm"  placeholder="textbookNm" v-validate="'required|min:2'"  name="textbookNm" style="width: 100%" />
              </td>
              <th>저자*</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('author')}"     v-model="data.author"  
                  placeholder="author" v-validate="'required|min:2'" name="author" style="width: 100%" />
              </td>
            </tr>
            <tr>
              <th>개정년도</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('pubDt')}" v-model="data.pubDt" 
                  placeholder="pubDt" v-validate="'digits:4'"  name="pubDt" style="width: 200px" />
              </td>
              <th>ISBN</th>
              <td>
                <span class="input-group">
                  <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('isbnCd')}" v-model="data.isbnCd"  
                    placeholder="ISBN" v-validate="''"  name="isbnCd" style="width: 170px"  />
                </span>
              </td>
              <th>저작권</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('license')}" v-model="data.license" 
                  placeholder="license" v-validate="''"  name="license" style="width: 100%"  />
              </td>
            </tr>
            <tr>
              <th>학교급*</th>
              <td colspan="3">
                <school-grade :params="data" @schoolType="changedSchoolType"/>
              </td>
              <th rowspan="4">교재이미지*</th>
              <td rowspan="4">
                <div class="custom-file" :class="{'is-invalid':errors.has('thumbnailUrl')}">
                  <input type="file" class="display-file" accept="image/*" id="thumbImage" @change="selectedThumbImage">
                  <label class="custom-file-label" for="thumbImage">Choose a file...</label>

                  <img class="popupImageItem" :src="page.thumbnailUrl">
                  <input type="hidden" v-validate="'required'" name="thumbnailUrl" :value="page.thumbnailUrl"/>
                  <span>{{page.thumbnailName}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <th rowspan="2">채널설정*</th>
              <td rowspan="2">
                <div>
                  <input type="checkbox" class="ml-1" name="teacherUseYn" v-model="data.teacherUseYn" true-value="Y" false-value="N">
                  <label class="form-check-label ml-1">교사 채널 사용</label>
                </div>
                <div>
                  <input type="checkbox" class="ml-1" name="tutorUseYn" v-model="data.tutorUseYn" true-value="Y" false-value="N">
                  <label class="form-check-label ml-1">강사 채널 사용</label>
                </div>
                <div>
                  <input type="checkbox" class="ml-1" name="kjquizUseYn" v-model="data.kjquizUseYn" true-value="Y" false-value="N">
                  <label class="form-check-label ml-1">깜짝퀴즈 사용</label>
                </div>
              </td>
              <th>노출 여부</th>
              <td>
                <input type="checkbox" class="ml-1" name="useYn" v-model="data.useYn" true-value="Y" false-value="N">
                <label class="form-check-label ml-1">※ 서비스에 노출하려면 체크하세요.</label>
              </td>
            </tr>
            <tr>
              <th>샘플 여부</th>
              <td>
                <input type="checkbox" class="ml-1" v-model="data.freeYn" name="freeYn" true-value="Y" false-value="N">
                <label class="form-check-label ml-1">※ 샘플교재로 제공하려면 체크하세요.</label>
              </td>
            </tr>
             <tr >
              <th>키워드</th>
              <td colspan='3'>
                 <Keyword :box="page.keywords.box" :boxText="page.keywords.text" :type="'key'" @keywordChange="keywordChange" @keywordRemove="keywordChange" :key="page.keywords.text"/>
              </td>
            </tr>
            <tr >
              <th>태그</th>
              <td colspan='3'>
                 <Keyword :box="page.tags.box" :boxText="page.tags.text" :type="'tag'" @keywordChange="keywordChange" @keywordRemove="keywordChange" :key="page.tags.text"/>
              </td>
              <th>등록자/등록일</th>
              <td>
                <input type="text" :class="{'form-control':true}" :value="`${page.regId}(${page.regDt})`" placeholder="regId" name="regId" style="width: 100%" readonly/>
              </td>
            </tr>
            <tr>
              <th>교재담당자*</th>
              <td colspan="3" style="position:relative;">
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('manNm')}"  v-model="page.adminInput" style="width: 100%" @change="getAdminList"/>
                <input type="hidden" v-model="data.manNm" name="manNm" v-validate="'required|min:1'"/>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary"
                  @click="getAdminList"
                  style="position: absolute;right: 0;top: 0.75rem;height: 35px;">
                  <em class="fa fa-search"></em>
                </b-btn>
                <div style="padding: 10px 5px 0;">{{page.adminDetail}}</div>
                <div class="search-box-wrap" v-show="page.adminList.length > 0">
                  <div class="search-box" v-for="item in page.adminList" :key="item.adminId" @click="selectedAdmin(item)" >
                      <span>{{item.name}}</span>
                      <span>{{item.email}}</span>
                      <span>{{item.mobileNo}}</span>
                  </div>
                </div>
              </td>
              <th>수정자/수정일</th>
              <td>
                <input type="text" :class="{'form-control':true}" :value="`${page.updId}(${page.updDt})`" placeholder="updId" name="updId" style="width: 100%" readonly/>
              </td>
            </tr>            
          </table>
        </form>
      </div>
      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="save()" class="btn btn-xs mr-2" type="submit" variant="outline-info">저장</b-button>
          <b-button v-if="bookSeq==0" @click="close()" class="btn btn-xs mr-2" variant="outline-info">취소</b-button>
          <b-button v-if="bookSeq!=0" @click="remove()" class="btn btn-xs mr-2" variant="outline-info">삭제</b-button>
          <b-button v-if="bookSeq!=0" @click="search()" class="btn btn-xs mr-2" variant="outline-info">목록</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->
</template>
<style scoped>
  .is-invalid {
    border:1px solid red;
  }
</style>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api';
import * as admApi from "@/api/sso/SsoAdmApi";
import * as textbookApi from "@/api/lm/LmTextBookApi";
import {dataObject,allSchoolItems,bookTypeCd,cateCd,subjectCd1,subjectCd2,subjectCd3,RsubjectCd,RsubjectCd1,RsubjectCd2,RsubjectCd3,RsubjectCd4,RsubjectCd5,aws_cdn_path} from "@/utils/Constants";
import SchoolGrade from "../../components/Common/SchoolGrade";
import Keyword from "../../components/Common/Keyword";
import { result } from 'lodash';
import swal from 'sweetalert2';

export default {
  components: {SchoolGrade, Keyword},
  props: {
   bookTypeCd:'',  // '330001' : 교과서, '330002' : 참고서
   bookSeq: {
     type:Number,
     default:0
   },
  },
  setup(props, context) {
    const _page = {
      subjectOption : RsubjectCd1,
      keywords:{box:[], text:''},
      tags:{box:[], text:''},
      allSchoolItems: allSchoolItems,
      subjectCd1 : subjectCd1,
      subjectCd2 : subjectCd2,
      subjectCd3 : subjectCd3,
      selectedSchoolType : '',
      initSubject : props.bookSeq == 0 ? false : true,
      adminParams : _.cloneDeep(dataObject.params),
      adminList : [],
      adminInput : '',
      adminDetail : '',
      thumbnailUrl: null, // 교재이미지 파일 Url 또는 데이터
      thumbnailName: '',
      regId : '',
      updId : '',
      regDt : '',
      updDt : '',
    };
    const page = reactive(_page);

    const _data = {
      bookSeq : props.bookSeq,
      contSeq : 0,
      bookTypeCd : props.bookTypeCd,
      textbookNm:'',
      bookId:'',
      isbnCd:'',
      teacherUseYn:'N',
      tutorUseYn:'N',
      kjquizUseYn:'Y',
      useYn : 'Y',
      freeYn : 'N',
      manNm : '',  // adminId
      pubDt :'',
      author :'',
      keywords : '',
      tags: '',
      cateCd : '',
      subjectCd : '',
      license : '',
      thumbnailFile : null, // 교재이미지 파일
      selectedSchools : [], // 선택된 학교급, 학년
    }
    const data = reactive(_data);

    const keywordChange = (box,text,type) =>{
      if(type == "key"){
        page.keywords.box = box;
        page.keywords.text = text;
        data.keywords = page.keywords.box.join(',');
      }else{
        page.tags.box = box;
        page.tags.text = text;
        data.tags = page.tags.box.join(',');
      }
    }

    const retVals = {
      page,
      data,
      keywordChange,
      cateCd,
      RsubjectCd,
      RsubjectCd1,
      RsubjectCd2,
      RsubjectCd3,
      RsubjectCd4,
      RsubjectCd5,
      ...methods(props, page, data, context),
    }

    onMounted(() => {
      if (props.bookSeq != 0) {
        retVals.getDetail(props.bookSeq);
      }
    });

    return retVals;
  },
}

function methods(props, page, data, context) {

  async function getDetail(bookSeq) {
    if (bookSeq != 0) {
      const _params = {bookSeq : bookSeq};
      const result = await textbookApi.getLmTextBookItem(_params);
      if (result && result.data) {
        const resultData = result.data;
        for (const property in resultData) {
          if (['thumbnailUrl', 'thumbnailName', 'regId', 'regDt', 'updId', 'updDt'].includes(property)) {
            page[property] = resultData[property];
          } else if (data.hasOwnProperty(property)) {
            data[property] = resultData[property];
          } 
        }
        this.setExtraInfo(resultData);

        // 단원/차시/개체
        context.emit('searchDepth', resultData);
      }
    }
  }

  async function setExtraInfo(resultData) {
    console.log('CsTextBookAddPage initInfo: props ', props);
    if (data.manNm) {
      const manNm = data.manNm;
      const result = await admApi.getSsoAdmItemById(manNm);
      if (result.data) {
        this.selectedAdmin(result.data);
      } else {
        page.adminInput = '';
        page.adminDetail = '';
        data.manNm = '';
      }
    }
    if (data.cateCd) {
      this.changeCateCd(data.cateCd, true);
    }
    if (data.keywords) {
      const keywordBox = data.keywords.split(/[\s,]+/);
      page.keywords.box = keywordBox;
      page.keywords.text = keywordBox.join(',');
    }
    if (data.tags) {
      const tagBox = data.tags.split(/[\s,]+/);
      page.tags.box = tagBox;
      page.tags.text = tagBox.join(',');
    }
    
    let selectedSchools = [];
    page.allSchoolItems.forEach((schItem, index) => {
      if (resultData[schItem.key] == 'Y') {
        selectedSchools.push(schItem.key);
      }
    });
    data.selectedSchools = selectedSchools;
  }

  function changeCateCd(cateCd, initSubject) {
    switch(cateCd){
      case '356001' : 
        page.subjectOption = RsubjectCd1;
      break;
      case '356002' : 
        page.subjectOption = RsubjectCd2;
      break;
      case '356003' : 
        page.subjectOption = RsubjectCd3;
      break;
      case '356004' : 
       page.subjectOption = RsubjectCd4;
      break;
      case '356005' : 
        page.subjectOption = RsubjectCd5;
      break;
    }

    if (!initSubject) {
      data.subjectCd = page.subjectOption[0].value;
    }
  }


  async function getAdminList() {
    page.adminParams.limit = 10000;
    page.adminParams.schText = page.adminInput;
    //page.adminParams.schText = event.target.value;

    data.manNm = '';
    page.adminDetail = '';
    const result = await admApi.getSsoAdmList(page.adminParams);
    page.adminList = result.data;
  }

  function selectedAdmin(item) {
    data.manNm = item.adminId;
    page.adminDetail = item.name + ' / ' + item.email + ' / ' + item.mobileNo;
    page.adminList = [];
    page.adminInput = item.adminId;
  }

  // 교재 이미지 선택
  function selectedThumbImage(event) {
    const input = event.target;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      // 파일 및 이미지 이름 설정
      data.thumbnailFile = file;
      page.thumbnailName = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        // 이미지 데이터      
        page.thumbnailUrl = e.target.result; 
      }
      reader.readAsDataURL(file);
    }
  }

  // 학교급이 변경된 경우 과목 초기값 설정
  function changedSchoolType(schoolType) {
    console.log('changedSchoolType called:initSubject', schoolType, page.initSubject);
    page.selectedSchoolType = schoolType;

    let isChanged = true;
    if (page.initSubject) {
      isChanged = false;
      page.initSubject = false;
    }

    if (isChanged && data.bookTypeCd == '330001') { // 교과서인 경우에만 적용, 참고서는 적용하지 않음
      if (schoolType == 'el') {
        data.subjectCd = page.subjectCd1[0].value;
      } else if (schoolType == 'mid') {
        data.subjectCd = page.subjectCd2[0].value;
      } else if (schoolType == 'high') {
        data.subjectCd = page.subjectCd3[0].value;
      } else {
        data.subjectCd = '';
      }
    } else {
      // data.subjectCd 는 변경되지 않는다.
    }
  }

  async function save() {
    if (data.selectedSchools.length == 0) {
      alert('학교급을 선택해주세요.');
      return;
    }

    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      alert('필수 입력 항목을 확인해주세요.');
      return;
    }
//NOTUSED 230317
//    let result = undefined;
//    //this.modalLoading = true;
//    if (data.bookSeq == 0) {
//        let formData = new FormData();
//        for (const property in data) {
//          formData.append(property, data[property]);
//        }
//        result = await textbookApi.saveNewLmTextBook(formData);
//    } else {
//        let formData = data;
//        result = await textbookApi.saveLmTextBook(formData);
//    }
//    //this.modalLoading = false;

    let formData = new FormData();
    for (const property in data) {
      formData.append(property, data[property]);
    }
    const result = await textbookApi.saveLmTextBook(formData);

    if (result && result.data) {
      if (props.bookSeq == 0) {
        const title = (data.bookTypeCd == '330001')? 'SmartSchool 교과서등록':'SmartSchool 참고서등록';
        const text = (data.bookTypeCd == '330001')? '교과서 등록완료!':'참고서 등록완료!';
        swal({
          title: title,
          text: text,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "OK",
          heightAuto: false
          }).then((result => {
            if(result.value){
            }
          }));
        this.search();
        this.close();
      } else {
        this.getDetail(props.bookSeq);
        alert('수정했습니다.');
      }
    };
  }

  function close() {
    context.emit('modal-state', 'addTextBook');
  }

  function search() {
    context.emit('search');
  }

  async function remove() {
    if (!confirm('교과서를 정말 삭제하시겠습니까?\n삭제하면 원복이 불가능합니다.')) {
      return;
    }
    const params = {bookSeq : data.bookSeq,
      contSeq:data.contSeq};
    const result = await textbookApi.deleteLmTextBook(params);
    alert('삭제했습니다.');
    this.search();
  }

  return {
    getDetail,
    setExtraInfo,
    changeCateCd,
    getAdminList,
    selectedAdmin,
    selectedThumbImage,
    changedSchoolType,
    save,
    close,
    search,
    remove,
  }
}

</script>